// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";

import UserTag from "./UserTag";
import GroupTag from "./GroupTag";
import type { UID, GroupId } from "src/types";
import { Stack } from "@chakra-ui/react";

type UsersAndGroups = {
  id?: GroupId,
  uid?: UID,
  type: string
};

type Props = {
  usersAndGroups: Array<UsersAndGroups>,
  handleRemove: (id: UID | GroupId) => void
};

const MultipleSelection = ({ usersAndGroups, handleRemove }: Props) => {
  return (
    <Stack
      data-cy="displayContainerUser"
      sx={{
        alignItems: "stretch",
        width: "100%"
      }}
    >
      {usersAndGroups.map((userOrGroup, index) => {
        if (userOrGroup.type === "user") {
          return (
            userOrGroup.uid && (
              <UserTag
                key={`${i18n.t(k.USER)}${index}`}
                // $FlowFixMe
                uid={userOrGroup.uid}
                handleRemove={handleRemove}
              />
            )
          );
        } else {
          return (
            userOrGroup.id && (
              <GroupTag
                key={`${i18n.t(k.GROUP)}${index}`}
                // $FlowFixMe
                id={userOrGroup.id}
                handleRemove={handleRemove}
              />
            )
          );
        }
      })}
    </Stack>
  );
};

export default MultipleSelection;
